"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.balancer = void 0;
exports.balancer = {
    router: '0xBA12222222228d8Ba445958a75a0704d566BF2C8',
};
